var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-dark m-0 p-3 d-flex justify-content-center align-items-center"},[(_vm.showIcon)?_c('i',{staticClass:"text-primary fa-fw mr-3",class:_vm.icon}):_vm._e(),_vm._t("default",function(){return [(_vm.title)?_c('div',{staticClass:"font-weight-400"},[_vm._v(_vm._s(_vm.title))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }